const commonLayoutStyles = {
    section: "py-6",
    headingContainer: "pb-[30px]",
    heading: "text-[38px] font-semibold container uppercase",
    commonDescription: "text-sm mb-1 flex flex-col-reverse min-[768px]:flex-row min-[768px]:items-baseline min-[768px]:justify-between w-full gap-4",
    listHeading: "text-2xl font-semibold mb-4 uppercase",
    content: "text-sm mb-4",
    list: "list-inside list-disc space-y-2 text-sm",
    




}

export { commonLayoutStyles }